import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import type { ImportRegelDto } from '../../domain/model/import-regel.model';

@Injectable({
    providedIn: 'root',
})
export class ImportRegelService {
    private http = inject(HttpClient);

    public getImportRegeln(): Observable<ImportRegelDto> {
        return this.http.get('/api/admin/import-regel') as Observable<ImportRegelDto>;
    }

    public updateImportRegeln(value: ImportRegelDto): Observable<any> {
        return this.http.put('/api/admin/import-regel', value) as Observable<any>;
    }
}
